import { Component, Inject, OnInit, ViewContainerRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CDSMask } from '@app/utils/cds-mask';
import { Receber } from '@app/models/receber.model';
import { ReceberService } from '@app/services/receber.service';

import { Processo } from '@app/models/processo.model';
import { ProcessoService } from '@app/services/processo.service';
// import { AutocompleteDataService } from '@app/services/autocomplete.service';

import { ToastrService } from 'ngx-toastr';
import { Unidade } from '@app/models/unidade.model';
import { ListaDR } from '@app/models/util/lista-dr';
import { ConsultasService } from '@app/services/consultas.service';
import debounce from '@app/utils/debounce';
//import { INgxSelectOption } from 'ngx-select-ex';
import { UtilitarioService } from '@app/services/utilitario.service';
import { UsuarioTipoService } from '@app/services/usuario-tipo.service';
import { IdDescricao } from '@app/models/util/id-descricao';



@Component({
  selector: 'app-receber-form',
  templateUrl: './receber-form.component.html'
})
export class ReceberFormComponent implements OnInit {
  aguardandoSolicitacao:boolean=false
  titulo: string;
  receber: Receber;
  cdsMask: CDSMask = new CDSMask();
  lstErros: string[];
  lstTipoDR: ListaDR[];

  // participanteDataService: AutocompleteDataService;
  processoId: number;

  gerarFatura = false;

  faturaQntParcela = 0;
  faturaIntervalorDias = 30;
  acessoAOutrasUnidades = false;
  lstUnidades: Unidade[];

  lstParticipante: Array<any> = [{}];
  participanteInicial: any = null;

  _debounce: any;
  _pesquisa: any;
  acessoOutrasUnidades: boolean;
  edicaoReceber = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private receberService: ReceberService,
    private processoService: ProcessoService,
    private consultasService: ConsultasService,
    @Inject(ToastrService) public toastr: ToastrService,
    private usuarioTipoService: UsuarioTipoService
  ) {
    this.receber = new Receber();
    // this.receber.DemonstrativoDeResultadoId = null;
    const hoje = new Date();
    this.receber.Emissao = hoje.toISOString().split('T')[0];
    this.receber.Vencimento = hoje.toISOString().split('T')[0];
    this.receber.Valor = 0;
    this.receber.NumeroCopias = 1;

  }


  ngOnInit() {

    this.consultasService.consultar('UNIDADE_S_RATEIO').toPromise().then(data => this.lstUnidades = data);
    this.consultasService.consultar('DR_R').toPromise().then(data => this.lstTipoDR = data);
    this.aguardandoSolicitacao=false;
    
    this.usuarioTipoService.verificaPermissaoUsuario().subscribe(
      (permissoes: any) =>{
        this.acessoOutrasUnidades = permissoes.find(x => x.Descricao == 'VisualizarOutrasUnidades').Selecionado;
      });

    this.route.params.subscribe(
      (params: any) => {
        const id = params['id'];
        this.processoId = params['processoid'];
        this.titulo = id ? 'Editar contas a receber ' : 'Lançar contas a receber ';
        // novo
        if (!id) {
          // verifica se é pela tela de processo
          const hoje = new Date();
          const hora = hoje.toLocaleTimeString().replace(':', '').replace(':', '');
          const ano = hoje.getFullYear();
          const mes = hoje.getMonth();
          this.receber.Numero = ano + '' + mes + '' + hora;
          if(this.processoId != undefined) {
            this.obterProcesso();
          }else{
            this.receber.UnidadeId = Number(UtilitarioService.retornaUnidadeUsuario());
          }
          // this.obterUnidades();
          // this.unidadeService.obterUnidadeUsuarioLogado().subscribe(data => this.receber.UnidadeId = data);
        } else {
          // editar
          this.receberService.obterPorId(id).toPromise().then(data => {
            this.receber = data;
            this.edicaoReceber = true;
            this.receber.Emissao = this.receber.Emissao.split('T')[0];
            this.receber.Vencimento = this.receber.Vencimento.split('T')[0];

            if (this.receber.Participante) {
              this.lstParticipante = [{ Id: this.receber.ParticipanteId, Descricao: this.receber.Participante.NomeFantasia }];
            }

            if (!(this.receber.ProcessoId > 0)) {
              this.acessoAOutrasUnidades = true;
              // this.obterUnidades();
            } else {
              this.acessoAOutrasUnidades = false;
            }
          });
        }
      });
  }

  obterProcesso() {
    if (!this.processoId) {
      return;
    }

    this.processoService.obterPorId(this.processoId).subscribe(
      (data: Processo) => {
        if (data != null) {
          this.receber.ProcessoId = data.Id;
          this.receber.ParticipanteId = data.ClienteId;
          this.receber.UnidadeId = data.UnidadeId
          this.lstParticipante = [{ Id: data.ClienteId, NomeFantasia: data.ClienteNome }];
        } else {
          this.router.navigate(['/dashboard']);
        }
      },
      () => this.router.navigate(['/dashboard']));
  }

  btnGerarFaturas() {
    if (this.receber.Id !== 0) {
      this.gerarFatura = true;
    } else {
      this.toastr.error('Salve o contas a receber antes de gerar as faturas', 'Notificação!');
    }
  }
  confirmarEnvioFaturas() {
    if (this.faturaQntParcela > 0 && this.faturaIntervalorDias > 0) {
      this.receberService.gerarFaturas(this.receber.Id, this.faturaQntParcela, this.faturaIntervalorDias)
        .subscribe(
          () => {
            this.toastr.success('Sucesso ao gerar faturas', 'Notificação!');
            this.gerarFatura = false;
            this.receber.Parcela = 1 + '/' + this.faturaQntParcela;
            this.lstErros = [];
          },
          (data: any) => {
            if (data.error) {
              this.lstErros = data.error.errors;
            }
          });
    } else {
      this.toastr.error('Preencha a quantidade de parcelas e o intervalo de dias corretamente', 'Notificação!');
    }
  }

  gravar() {
    this.aguardandoSolicitacao=true
    const receber = { ...this.receber };
    receber.DemonstrativoDeResultado = null;
    receber.Participante = null;
    this.receberService.gravar(receber)
      .subscribe(
        (data: any) => {
          this.redirecionar();
        },
        (data: any) => {
          if (data.error) {
            this.lstErros = data.error.errors;
          }
          this.aguardandoSolicitacao=false
        });
  }


  btnVoltar() {
    this.redirecionar();
  }

  private redirecionar() {
    if (this.processoId > 0) {
      this.router.navigate(['/processos/processo', this.receber.ProcessoId, 'financeiro']);
    } else {
      this.router.navigate(['/financeiro/receber']);
    }
  }

}
